var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_1648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4.2C23.9987 3.08648 23.5558 2.01893 22.7684 1.23155C21.9811 0.444177 20.9135 0.00127042 19.8 0L4.2 0C3.08648 0.00127042 2.01893 0.444177 1.23155 1.23155C0.444177 2.01893 0.00127042 3.08648 0 4.2L0 21.6C0 22.2365 0.252856 22.847 0.702944 23.2971C1.15303 23.7471 1.76348 24 2.4 24H21.6C22.2365 24 22.847 23.7471 23.2971 23.2971C23.7471 22.847 24 22.2365 24 21.6V4.2ZM16.9848 12C16.5347 12.0101 16.107 12.1981 15.7953 12.5229C15.4836 12.8476 15.3132 13.2827 15.3216 13.7328C15.3216 14.6137 14.9716 15.4586 14.3487 16.0815C13.7258 16.7044 12.8809 17.0544 12 17.0544C11.1191 17.0544 10.2742 16.7044 9.65127 16.0815C9.02835 15.4586 8.6784 14.6137 8.6784 13.7328C8.68677 13.2827 8.51644 12.8476 8.20471 12.5229C7.89298 12.1981 7.46526 12.0101 7.0152 12H4.2C4.04087 12 3.88826 11.9368 3.77574 11.8243C3.66321 11.7117 3.6 11.5591 3.6 11.4V4.2C3.6 4.04087 3.66321 3.88826 3.77574 3.77574C3.88826 3.66321 4.04087 3.6 4.2 3.6H19.8C19.9591 3.6 20.1117 3.66321 20.2243 3.77574C20.3368 3.88826 20.4 4.04087 20.4 4.2V11.4C20.4 11.5591 20.3368 11.7117 20.2243 11.8243C20.1117 11.9368 19.9591 12 19.8 12H16.9848Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_1648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.854dfe1710934c8ba0ce402669044901.svg";
export { ForwardRef as ReactComponent };